import type { ComponentPropsWithoutRef, FC } from 'react';
import { cn } from 'src/utils/cn';

type FormHintProps = {
  isDisabled?: boolean;
  isSelected?: boolean;
} & ComponentPropsWithoutRef<'small'>;

export const FormHint: FC<FormHintProps> = ({
  isDisabled,
  isSelected,
  ...props
}) => {
  return (
    <div>
      <small
        {...props}
        className={cn(
          isDisabled
            ? 'text-foreground-surface-disabled'
            : isSelected
              ? 'text-white'
              : 'text-foreground-surface-subdued',
          props.className
        )}
      />
    </div>
  );
};
